import type { PanelProps } from '../types';
import { PanelList } from './PanelList';
import './Panel.scss';
export function Panel({
  autocomplete,
  collections,
  highlightedIndex,
  onKeyDown,
  query
}: PanelProps) {
  return <div className="autocomplete-panel" {...autocomplete.getPanelProps({})}>
            <div className="autocomplete-panel-layout" data-testid="autocomplete-panel">
                {(() => {
        let remainingIndex = highlightedIndex;
        return collections.map(collection => {
          const {
            source,
            items
          } = collection;
          const createPanelList = (collectionIndex: number) => <PanelList autocomplete={autocomplete} source={source} items={items} highlightedIndex={collectionIndex} onKeyDown={onKeyDown} key={source.sourceId} query={query} />;
          if (remainingIndex < items.length) {
            const panelList = createPanelList(remainingIndex);
            remainingIndex = -1;
            return panelList;
          }
          remainingIndex -= items.length;
          return createPanelList(-1);
        });
      })()}
            </div>
        </div>;
}